import types from './types';


const updateList = (data) => ({
	type: types.UPDATE_LIST,
	payload: data
})

const updatePinned = (data) => ({
	type: types.UPDATE_PINNED,
	payload: data
})

const updateDetails = (data) => ({
	type: types.UPDATE_DETAILS,
	payload: data
})


const clearList = () => ({
	type: types.CLEAR_LIST,
})

const updateSchedule = (data) => ({
	type: types.UPDATE_SCHEDULE,
	payload: data
})


export default {
	updateList,
	updatePinned,
	updateDetails,
	updateSchedule,
	clearList
};
